import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const LandingCardBase: FC<{
  className?: string;
  rounded?: boolean;
  children?: ReactNode;
  [key: string]: any;
}> = ({ className = '', children, rounded = true, ...props }) => {
  return (
    <div
      className={twMerge(
        'flex w-full flex-row items-center justify-center bg-[#EBEFF2] p-16',
        className,
        rounded && 'rounded-3xl'
      )}
      {...props}
    >
      {children}
    </div>
  );
};
